import { numberToPrettyString } from '@cian/utils';

import {
  ECurrency,
  EPeriod,
  IPriceForMobileSite,
} from '../../../../../common/repositories/dailyrent/entities/price_for_mobile_site/PriceForMobileSite';

export type TPriceVariant = 'default' | 'recommendation';

export const currencyToString = (currency: ECurrency) => {
  switch (currency) {
    case ECurrency.Eur:
      return '€';
    case ECurrency.Usd:
      return '$';
    case ECurrency.Rur:
    default:
      return '₽';
  }
};

interface IFormatPriceProps extends Pick<IPriceForMobileSite, 'value' | 'currency'> {}

export const formatPrice = (price: IFormatPriceProps, hasDates: boolean) => {
  const number = numberToPrettyString(price.value);
  const currency = currencyToString(price.currency);

  return hasDates ? `${number} ${currency}/сут.` : `от ${number} ${currency}/сут.`;
};

const getPeriodSuffix = (period: IPriceForMobileSite['period']): string => {
  switch (period) {
    case EPeriod.Day:
      return '/сут.';
    case EPeriod.Month:
      return '/мес.';
    default:
      return '';
  }
};

interface IFormatRecommendationPriceProps extends Pick<IPriceForMobileSite, 'value' | 'currency' | 'period'> {}

/**
 * Цена в рекомендациях «Вам могут подойти»: суффикс — по периоду из ответа
 * (рекомендации могут быть и долгосрочной арендой, и продажей без периода).
 * «от» — только у посуточных, и в отличие от основной выдачи всегда,
 * независимо от выбранных дат в фильтрах.
 */
export const formatRecommendationPrice = (price: IFormatRecommendationPriceProps) => {
  const number = numberToPrettyString(price.value);
  const currency = currencyToString(price.currency);
  const isDailyPrice = price.period === EPeriod.Day;
  const prefix = isDailyPrice ? 'от ' : '';

  return `${prefix}${number} ${currency}${getPeriodSuffix(price.period)}`;
};
